import {HttpErrorResponse} from "@angular/common/http";
import {Observable, throwError} from "rxjs";
import {Injectable} from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class HelperUtils {

    // Global Error Handling
    static handleError(error: HttpErrorResponse): Observable<HttpErrorResponse> {
        return throwError(() => error);
    }
    // Convert string to array
    static stringToArray(stringValues: string): any[] {
        if (stringValues) {
            return stringValues.split(",").map(Number);
        }
        return [];
    }

}
